export default {
  readvertisement: {
    modal: {
      title: {
        readvertise: "Confirm Readvertisement",
        schedule: "Confirm Schedule Readvertisement",
        copy: "Copy Schedule Readvertisement",
      },
      description:
        "You’ve selected {count} listing{count, plural, =0 {} =1 {} other{s}} to readvertise. ",
      list: {
        label: "{count} x {label} listing{count, plural, =0 {} =1 {} other{s}}",
        credit: "{expend} Ad credit{expend, plural, =0 {} =1 {} other{s}}",
        listingInfo: `Price: <span class="value">RM{price}</span> | Property type: <span class="value">{type}</span> | ID: <span class="value">{id}</span> | Tier: <span class="value">{tier}</span>`,
      },
      summation: {
        deduction: "Total deductions",
        balance: "Balance:",
        credit: "{expend} Ad credit{expend, plural, =0 {} =1 {} other{s}}",
      },
      tips: "*Credits are deducted as the readvertisement occurs.",
      cancel: "Cancel",
      confirm: {
        readvertise: "Confirm Readvertisement",
        schedule: "Confirm Schedule Re-Ad",
        copy: "Confirm",
      },
      message: {
        success: "Your listing has been readvertised.",
        failed: "Failed to readvertise. Your listing is not readvertised.",
      },
      form: {
        title: "Set your schedule",
        error: {
          pastedTime: "Unable to schedule on past date time",
          pastedDate: "Unable to schedule on past date",
          outRange: "Invalid days detected within the date range",
        },
        scheduleName: {
          label: "Schedule name",
          placeholder: "",
        },
        scheduleType: {
          label: "Schedule type",
          placeholder: "Select one",
        },
        startDate: {
          label: "Active start date",
          placeholder: "Choose date",
        },
        endDate: {
          label: "Active end date",
          placeholder: "Choose date",
        },
        activeDay: {
          label: "Active day",
          placeholder: "Select one",
        },
        startTime: {
          label: "Active start time",
          placeholder: "Select one",
        },
      },
    },
  },
};
